import React from 'react';

export type MinerBadgeStatus = 'active' | 'unlocked' | 'locked' | 'paused' | 'claiming';

export interface MinerStatusBadgeProps {
  status: MinerBadgeStatus;
  label?: string;
  className?: string;
}

export const MinerStatusBadge: React.FC<MinerStatusBadgeProps> = ({
  status,
  label,
  className = '',
}) => {
  const config = {
    active: {
      text: label || 'Active & Mining',
      container: 'bg-emerald-500/15 border-emerald-500/30 text-emerald-300',
      dot: 'bg-emerald-400 shadow-[0_0_8px_#34d399]',
      pulse: true,
    },
    unlocked: {
      text: label || 'Unlocked',
      container: 'bg-cyan-500/15 border-cyan-500/30 text-cyan-300',
      dot: 'bg-cyan-400 shadow-[0_0_8px_#22d3ee]',
      pulse: true,
    },
    locked: {
      text: label || 'Locked',
      container: 'bg-gray-800/50 border-white/10 text-gray-400',
      dot: 'bg-gray-500',
      pulse: false,
    },
    paused: {
      text: label || 'Paused',
      container: 'bg-amber-500/15 border-amber-500/30 text-amber-300',
      dot: 'bg-amber-400',
      pulse: false,
    },
    claiming: {
      text: label || 'Claiming...',
      container: 'bg-purple-500/15 border-purple-500/30 text-purple-300',
      dot: 'bg-purple-400 animate-ping',
      pulse: true,
    },
  }[status];

  return (
    <span
      className={`inline-flex items-center space-x-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider border backdrop-blur-md ${config.container} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${config.dot} ${config.pulse ? 'animate-pulse' : ''}`} />
      <span>{config.text}</span>
    </span>
  );
};
